import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=1a4c7e72&"
import script from "./Health.vue?vue&type=script&lang=js&"
export * from "./Health.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports